import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import CustomSelect from "../../../../common/interactive/CustomSelect";
import { caseActions } from "../../../../../store/case";
import { caseQuickUpdate } from "../../../../../lib/fetchApi";
import { notificationActions } from "../../../../../store/notifications";
import { retrievePayerStatuses, retrievePayerTypes } from "../../../../../lib/systemData";
import PayerTypeStatusGlobalModal from "../../../../common/modal/PayerTypeStatusGlobalModal";
import BodySimpleModalV3 from "../../../../common/modal/BodySimpleModalV3";
import { isMismatchedOption } from "../../../../../lib/script";

export default function PayerStatus({isDisabled}) {
    const dispatch = useDispatch()
    const activeCase = useSelector(state => state.case.activeCase)   
    const userToken = useSelector(state => state.user.token)


    const [selectedPayerStatus, setSelectedPayerStatus] = useState(activeCase?.case?.case_payer_status_id ? activeCase?.case?.case_payer_status_id : '')

    const [options, setOptions] = useState(null)

    const updateHandler = async (data) => {
            let reqBody = {
                type: data.identifier.type,
                type_id: data.identifier.type_id,
                fields: {
                    [data.identifier.field] : data.data.value,
                }
            }
    
            let dispatchObj = {
                folder: data.identifier.folder,
                item: {
                    fields: [
                        {
                            field: data.identifier.field,
                            value: data.data.value
                        },
                    ]            
                }
            }
            setTimeout(() => {
                dispatch(caseActions.modifyActiveCaseMultipleObject(dispatchObj))
            }, 0)
            
    
            let update = await caseQuickUpdate(userToken, activeCase.case.id, reqBody, dispatch)
    
            if (update && update.errorMessage) {
                dispatch(notificationActions.setError(update))
            }        
            
    }
    function statusesChangeHandler(params) {
        setSelectedPayerStatus(params.data.value ? params.data.value : '')
        updateHandler(params)    
    }

    useEffect(() => {
        setSelectedPayerStatus(activeCase?.case?.case_payer_status_id ? activeCase?.case?.case_payer_status_id : '')
        if (activeCase && activeCase.case) {
            let options = retrievePayerTypes()  
           
            if (activeCase?.case?.case_payer_type_id) {
                let item = options.find(item => item.value == activeCase?.case?.case_payer_type_id)

                let sOptions = []
                if (item) {
                    item.payer_statuses.forEach(element => {
                        sOptions.push({
                            label: element.name,
                            value: element.id,
                            color: element.color,
                            color_code: element.color_code,
                            isDisabled: !element.active,
                            manual_selection: element.manual_selection
                        })
                    });

                    setOptions(sOptions)
                }
                
            } else {
                setOptions([
                    {label: 'Undetermined', value: null, default_selected_value: true}                      
                ])
            }
        }

    }, [activeCase?.case])

    return <>
        {/* <PayerTypeStatusGlobalModal date={activeCase?.case?.case_payer_status_date} user={activeCase?.case?.case_payer_status_by}>
            <CustomSelect isDisabled={isDisabled} label={'Payer Status'} optionsData={options} action={statusesChangeHandler} preSelectedValue={selectedPayerStatus} identifier={{type: 'case', field: 'case_payer_status_id', folder: 'case'}} undetermined={selectedPayerStatus == '' ? 'Undetermined' : null}/>
        </PayerTypeStatusGlobalModal> */}
       <PayerTypeStatusGlobalModal date={activeCase?.case?.case_payer_status_date} user={activeCase?.case?.case_payer_status_by} isDisabled={isMismatchedOption(selectedPayerStatus, options)}>
            <BodySimpleModalV3 disabled={!isMismatchedOption(selectedPayerStatus, options)} message={`Mismatch with current Payer Type, value is: ${retrievePayerStatuses()?.find(item => item.value == selectedPayerStatus)?.label}`}>
                <CustomSelect
                    isDisabled={isDisabled}
                    label={'Payer Status'}
                    optionsData={options}
                    action={statusesChangeHandler}
                    preSelectedValue={selectedPayerStatus}
                    identifier={{type: 'case', field: 'case_payer_status_id', folder: 'case'}}
                    undetermined={selectedPayerStatus == '' ? 'Undetermined' : null}
                    isMismatched={isMismatchedOption(selectedPayerStatus, options)}
                    fallbackSelectedOption={(value) => {
                        const found = retrievePayerStatuses()?.find((item) => item.value == value)
                        if (!found) return null
                        // Display-only; keep hidden from dropdown.
                        return { ...found, isDisabled: true }
                    }}
                />
            </BodySimpleModalV3>
        </PayerTypeStatusGlobalModal>
    </>
}